import { StatsLvl } from './StatsLvl';
import { EventStatusType } from './SportStatus';
import { CoverageType } from './CoverageType';
import { SportId, SubSportId } from '@libs/sports-api-consts';

export const enum EventItemStatus {
    Active = 'active',
    Deleted = 'deleted'
}

export const enum EventFtOnly {
    Yes = 'yes',
    No = 'no'
}

export const enum EventClockStatus {
    Stopped = 'stopped',
    Running = 'running'
}

export const enum BetMarketStatus {
    Active = 'active',
    Suspended = 'suspended',
    EarlySuspended = 'early suspended'
}

export interface Event {
    id: number
    ls_id: number | null
    name: string
    start_date: string
    ft_only: EventFtOnly
    group_id: number | null
    event_stats_lvl: StatsLvl
    event_stats_lvl_live: StatsLvl
    coverage_type: CoverageType
    status_id: number
    status_type: EventStatusType
    status_name: string
    sport_id: SportId
    sport_name: string
    clock_time: number | null
    sub_sport_name: string | null
    sub_sport_id: SubSportId | null
    /**
     * Since events can be cached on our side and PushCache messages have clock_time
     * that is frozen in time of message generation, we need to account for that if we want
     * to have clock_time that is valid for current moment
     */
    clock_difference?: number
    clock_status: EventClockStatus
    day: string
    round_id: number | null
    round_name: '' | string
    venue_id: '' | number
    bet_status: BetMarketStatus
    bet_cards: BetMarketStatus
    bet_corners: BetMarketStatus
    ut: number
    provider_id: number
    item_status: EventItemStatus
}
